module.exports = __webpack_public_path__ + "static/media/pic21.9ef87ee1.jpg";